import React from "react";
import flowers from "../data/compozitiiDeIarna";
import FlowerContainer from "../components/FlowerContainer";

const CompozitiiDeIarna = () => {
  return (
    <FlowerContainer
      flowers={flowers}
      title="Compoziții de iarna"
      subtitle="Aranjamente festive, concepute pentru a aduce magia iernii în casa ta, la locul de muncă sau ca un cadou special pentru cei dragi."
      storageKey="COMPOZITII_DE_IARNA_SCROLL_POSITION"
    />
  );
};

export default CompozitiiDeIarna;
